import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return [ "width", "length", "height", "code", 'oneRateCode', "name", "volume", "tare_weight",
           'id', 'updatedAt', "submitBtn", "editBtn", "errors", "removeBtn", "cancelBtn", 'conveyance'];
  }
 
  initialize(){
     
    if (!this.data.get('id')){
      this.edit();
      this.submitBtnTarget.setAttribute('data-action', "click->box#create")
      this.clearData();
    }
  }
  edit(event){
  
    $('#box-table-container').addClass('no-more-tables');
    $(this.element).removeClass('unfocused');
    this.submitBtnTarget.style.display = 'inline';
    this.cancelBtnTarget.style.display = "inline";
    this.editBtnTarget.style.display = "none";
  }

  cancel(){

    $('#box-table-container').removeClass('no-more-tables');
    $(this.element).addClass('unfocused');
 
    this.submitBtnTarget.style.display = 'none';
    this.errorsTarget.style.display = 'none';
    this.editBtnTarget.style.display = "inline";
    this.cancelBtnTarget.style.display = "none";
    if (!this.data.get('id')){
        $(this.element).remove();
        return;
     }
  }

  update(){
    let id = this.data.get('id'); 
    let t = this;
    axios.defaults.headers.common['Accept'] = 'application/json';
    axios.put('/rmrc_ad/box_manager/'+ id, t.buildPayload())
        .then(function(response){
            t.cancel(); 
            $(t.element).addClass('success');
            t.boxManagerController().setCurrentQuery();
            t.boxManagerController().goToPage();

        }).catch(function(err){
           t.errorsTarget.innerHTML = err.response.data.errors;
           t.errorsTarget.style.display = "block";
        })
  }

  destroy(){
    let id = this.data.get('id'); 
    let t = this;
    let confirmDelete = confirm("Are you sure?");
    

    if (confirmDelete === true) {
    
     if (!id){
      $(t.element).fadeOut();
      t.boxManagerController().goToPage();
     }
    axios.defaults.headers.common['Accept'] = 'application/json';
    axios.delete('/rmrc_ad/box_manager/'+ id)
        .then(function(response){ 
            $(t.element).fadeOut();
            t.boxManagerController().goToPage();

        }).catch(function(err){
           
        })
     }
  }

  create(){
    let t = this;
    axios.defaults.headers.common['Accept'] = 'application/json';
    axios.post('/rmrc_ad/box_manager/', t.buildPayload())
        .then(function(response){
            t.data.set('id', response.data.box.id);
            t.cancel(); 
            $(t.element).addClass('success');
            setTimeout(function(){
            t.boxManagerController().goToPage();
            }, 1000); 

        }).catch(function(err){
           t.errorsTarget.innerHTML = err.response.data.errors;
           t.errorsTarget.style.display = "block";
        })
  }
  
  recalcVolume(){
    this.volumeTarget.innerHTML =  (this.getValue('height') * this.getValue('length') * this.getValue('width')).toFixed(2);
  }

  getValue(metric){ 

    let value = parseFloat(this[metric +"Target"].value);

    return  value !== value ? 0.0 : value; 
  }

  clearData(){
    this.data.set('id', ""); 
    let  t = this;
    ["width", "length", "height", "code", "name", "tare_weight"].forEach(function(v){
      t[v+'Target'].value = "";
    });

    ["id", 'volume', 'updatedAt'].forEach(function(v){
        t[v+'Target'].innerText = "--";
    });

  }
 
   boxManagerController() {
    let element = document.querySelector('div[data-controller="box-manager"');
    return this.application.getControllerForElementAndIdentifier(element, "box-manager")
  }

  buildPayload(){
    return  {
      "box" : {
       "width": this.getValue('width'),
       "length": this.getValue('length'),
       "height": this.getValue('height'), 
       "tare_weight": this.getValue('tare_weight'), 
       "code": this.codeTarget.value,  
       "name": this.nameTarget.value, 
       "one_rate_code": this.oneRateCodeTarget.value,
       "conveyance_id": this.conveyanceTarget.value
      }

    }
  }

  
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/box_controller.js